import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { orderDetail } from "../../../redux/actions/orderActions";
import CurrentOrdersViewTable from "../../tables/currentOrdersViewTable";
import "../modal.css";
import LoadingSpinnerTable from "../../utilites/loader";
import OrderHistoryPdfView from "./orderHistoryPdfViewModal";

const OrdersHistoryModal = ({ Show, ShowClose, id }) => {
  const dispatch = useDispatch();
  const [orderHistoryDetail, setOrderHistoryDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pdfView, setPdfView] = useState(false);

  useEffect(() => {
    if (Show) {
      dispatch(orderDetail(id, onSuccess, onError));
      setLoading(true);
    }
  }, [Show]);

  const onSuccess = (data) => {
    console.log(data);
    setOrderHistoryDetail(data.data.data);
    setLoading(false);
  };
  const onError = (err) => {
    console.log(err);
    setLoading(false);
  };

  const data = [
    {
      title: "Order ID",
      content: orderHistoryDetail?.order_id
        ? orderHistoryDetail?.order_id
        : "--",
    },
    {
      title: "Order Date & Time",
      content: orderHistoryDetail?.createdAt
        ? moment(orderHistoryDetail?.createdAt).format("DD MMM YYYY, HH:mm A")
        : "--",
    },
    {
      title: "Invoice ID",
      content: orderHistoryDetail?.invoices?.map((item, index) => {
        if (index < orderHistoryDetail?.invoices?.length - 1) {
          return item?.invoice_id ? item?.invoice_id + "," : "--";
        } else return item?.invoice_id ? item?.invoice_id : "--";
      }),
    },
    {
      title: "Invoicing Date & Time",
      content: orderHistoryDetail?.updatedAt
        ? moment(orderHistoryDetail?.updatedAt).format("DD MMM YYYY, HH:mm A")
        : "--",
    },
  ];

  const data2 = [
    {
      title: "Division",
      content: orderHistoryDetail?.vendorDivision?.name
        ? orderHistoryDetail?.vendorDivision?.name
        : "--",
    },
    {
      title: "Doctor Name",
      content: orderHistoryDetail?.doctor?.name
        ? orderHistoryDetail?.doctor?.name
        : "--",
    },
    {
      title: "Pharmacy Name",
      content: orderHistoryDetail?.pharmacy_id
        ? orderHistoryDetail?.pharmacy?.pharmacy_name
        : orderHistoryDetail?.doctor?.pharmacy_type == "attach"
          ? orderHistoryDetail?.doctor?.doctorAttachPharmacy?.pharmacy
            ?.pharmacy_name
          : orderHistoryDetail?.doctor?.pharmacy_type == "self"
            ? orderHistoryDetail?.doctor?.doctorSelfPharmacy?.pharmacy_name
            : orderHistoryDetail?.doctor?.pharmacy_type == "dispensing" &&
            "Dispensing",
    },
    ,
    {
      title: "Order Status",
      content: orderHistoryDetail?.status ? orderHistoryDetail?.status : "--",
    },
  ];

  return (
    <>
      <Modal
        centered
        show={Show}
        onHide={ShowClose}
        dialogClassName="current-orders-view-container col-10 mx-auto px-3"
      //   size="lg"
      >
        <ModalHeader>
          <div className=" d-flex justify-content-between w-100 ">
            <div>
              <span className="fn_Nunito fw_700 fs_14 Medium_Purple my- px-0">
                {orderHistoryDetail?.order_id} - View
              </span>
            </div>
            <div className="d-flex justify-content-end  gap-2">
              <div>
                <button
                  onClick={() => {
                    ShowClose();
                    setPdfView(true);
                  }}
                  className="modal-submit-btn text-white px-4 py-2 fs_12"
                  type="button"
                >
                  <span className="px-">Print</span>
                </button>
              </div>
              <button
                className="modal-close-btn px-3 py-1 fs_12"
                onClick={() => ShowClose()}
              >
                close
              </button>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          {loading == true ? (
            <LoadingSpinnerTable />
          ) : (
            <div className="w-100 h-100">
              <div className="mx-2">
                <div className="d-flex ">
                  <div className="col-6 col-lg-6">
                    {data.map((items, index) => (
                      <div className="d-flex gap-" key={index}>
                        <div className="col-6 col-sm-5">
                          <span className="color_b0b3c7 fs_12">
                            {items?.title}
                          </span>
                        </div>
                        <span className="fs_12 ms-3 mt-1">
                          {items?.content}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div className="col-6">
                    {data2.map((items, index) => (
                      <div className="d-flex" key={index}>
                        {items?.title != "Order Status" ? (
                          <>
                            <div className="col-6 col-sm-4">
                              <span className="color_b0b3c7 fs_12">
                                {items?.title}
                              </span>
                            </div>
                            <span className="fs_12 ms-3 col-6 mt-1">
                              {items?.content}
                            </span>
                          </>
                        ) : (
                          <>
                            <div className="col-6 col-sm-4">
                              <span className={`color_b0b3c7 fs_12`}>
                                {items?.title}
                              </span>
                            </div>
                            <span
                              className={`fs_12 ms-3 col-6 mt-1 ${orderStatus.find(
                                (e) => e?.status == items?.content
                              )?.color
                                }`}
                            >
                              {
                                orderStatus.find(
                                  (e) => e?.status == items?.content
                                )?.value
                              }
                            </span>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mt-3">
                  <p className="fn_Nunito fw_700 fs_14 Medium_Purple my- px-2 label-text ">
                    Order Details - {orderHistoryDetail?.order_id}
                  </p>
                  <div className="mt-3">
                    <CurrentOrdersViewTable
                      orderProducts={orderHistoryDetail?.orderProducts}
                      total={orderHistoryDetail?.total}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </ModalBody>
      </Modal>
      <OrderHistoryPdfView
        orderHistoryDetail={orderHistoryDetail}
        id={id}
        show={pdfView}
        handleClose={() => setPdfView(false)}
      />
    </>
  );
};

export default OrdersHistoryModal;

export const orderStatus = [
  { status: "pending", value: "Approval Pending", color: "text-warning" },
  { status: "approved", value: "Approved", color: "color_2ad3e7" },
  { status: "fully_invoiced", value: "Fully Invoiced", color: "text_green" },
  {
    status: "partially_invoiced",
    value: "Partially Invoiced",
    color: "Medium_Purple",
  },
  { status: "rejected", value: "Rejected", color: "text-danger" },
  { status: "approval_failed", value: "Approval Failed", color: "text-danger" },
  { status: "cancelled", value: "Cancelled", color: "text-danger" },
  { status: "expired", value: "Expired", color: "text-danger" },
  { status: "acknowledged", value: "Acknowledged", color: "ack_status" },
  {
    status: "partially_acknowledged",
    value: "Partially acknowledged",
    color: "Medium_Purple",
  },
  { status: "hold", value: "Hold", color: "text-danger" },
];
